/**
 * Format INR the way AiSensy does: keep up to 5 decimal places so
 * 0.8631 + markup is visible, and 500.00000 − 0.95310 = 499.04690.
 * Trailing zeros beyond 2 dp are dropped (₹0.92 stays ₹0.92, ₹0.8631 stays ₹0.8631).
 */
export function fmtINR(v) {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "₹0.00";
  return `₹${n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
  })}`;
}
